import { SharedState } from '@trello/shared-state';

export const newUserShowInboxSpotlightSharedState = new SharedState<boolean>(
  true,
);
